import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { HowItWorks } from './components/HowItWorks';
import { WhyNorthforge } from './components/WhyNorthforge';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { useTheme } from './hooks/useTheme';
import { useScrollReveal } from './hooks/useScrollReveal';

export function App() {
  const { theme, toggleTheme } = useTheme();
  useScrollReveal();

  return (
    <div className="min-h-screen bg-bg font-body text-ink transition-colors duration-[450ms]">
      <Header theme={theme} onToggleTheme={toggleTheme} />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <WhyNorthforge />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
